import React, { useState } from 'react';
import { api } from '../services/api';

/**
 * Upis izmerenih dimenzija vozila i zapremina kategorija.
 *
 * ZAŠTO DUGME POSTOJI
 *   Oba sejanja su do 28.09.2026. mogla da se pokrenu samo pokretanjem testa —
 *   nijedan ekran ih nije zvao. Na svežoj mašini to znači da popunjenost vozila
 *   ne radi, a niko nema čime da je uključi.
 *
 * Ne gazi ljudski rad: potvrđena zapremina i izmerena dimenzija ostaju kakve
 * jesu, dopisuje se samo ono čega nema. Zato se sme pritisnuti ponovo.
 */
export default function Measurements() {
  const [busy, setBusy] = useState(false);
  const [ishod, setIshod] = useState<string | null>(null);
  const [greska, setGreska] = useState<string | null>(null);

  // VOZNI PARK IZ REGISTRA. Servis je postojao, a nijedan ekran ga nije zvao
  // (analiza 2.0, B7) — novo vozilo nije moglo na turu dok ga neko ne upiše.
  const [syncBusy, setSyncBusy] = useState(false);
  const [syncIshod, setSyncIshod] = useState<string[] | null>(null);

  const syncFleet = async () => {
    setSyncBusy(true);
    setGreska(null);
    setSyncIshod(null);
    try {
      const r = await api.syncVehicles();
      setSyncIshod([
        `Novih: ${r.novih}. Aktivnih teretnih: ${r.aktivnihTeretnih}, od toga sa zapreminom ${r.saZapreminom}.`,
        ...(r.promene.length === 0 ? ['Nema promena u registru.'] : r.promene)
      ]);
    } catch (e) {
      setGreska(e instanceof Error ? e.message : String(e));
    } finally {
      setSyncBusy(false);
    }
  };

  const seed = async () => {
    setBusy(true);
    setGreska(null);
    setIshod(null);

    try {
      const r = await api.seedMeasurements();

      setIshod(
        `Vozila: ${r.vozila.izmerenih} izmerenih, ${r.vozila.privremenih} privremenih. `
        + `Od ${r.vozila.aktivnihTeretnih} aktivnih teretnih, ${r.vozila.saZapreminom} ima zapreminu. `
        + `Kategorije: dopisano ${r.kategorije.dopisano}, `
        + `bez zapremine ostaje ${r.kategorije.bezZapremine}, `
        + `potvrđenih nedirnuto ${r.kategorije.potvrdjenihNedirnuto}.`
      );
    } catch (e) {
      setGreska(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="panel">
      <h2>Mere vozila i zapremine</h2>

      <p className="note">
        Upisuje izmerene dimenzije vozila i procene zapremina po kategoriji robe —
        bez njih se popunjenost vozila ne može izračunati, pa na ekranu piše da se
        ne zna. Ono što je čovek izmerio ili potvrdio se <strong>ne dira</strong>,
        dopisuje se samo ono čega nema. Može se pritisnuti ponovo bez štete.
      </p>

      <button type="button" className="primary" disabled={busy} onClick={() => void seed()}>
        {busy ? 'Upisujem…' : 'Upiši ono čega nema'}
      </button>

      {ishod && <p className="health health--ok">{ishod}</p>}

      <p className="note">
        Vozni park iz registra vozila: nova vozila, ugašena i nove registracije. Mesto
        vozila i izmerena zapremina se ne diraju. Pokreni kad se u registru nešto promeni.
      </p>

      <button type="button" disabled={syncBusy} onClick={() => void syncFleet()}>
        {syncBusy ? 'Preuzimam…' : 'Preuzmi vozila iz registra'}
      </button>

      {syncIshod && (
        <ul className="health health--ok">
          {syncIshod.map((red) => <li key={red}>{red}</li>)}
        </ul>
      )}

      {greska && <p className="health health--bad">{greska}</p>}
    </section>
  );
}
